/* ============================================================================
   dena-hex-lightbox.js — V152/V153 · Ürün galerisi tam ekran görüntüleyici
   ----------------------------------------------------------------------------
   NEDEN YENİ MOTOR (V152): Eski hal (V129) sahnede çift dokunuşla 2.2×
   büyütüyor ama büyüyünce gezinmeye izin vermiyordu; V72/V86 tam ekran
   penceresi açan düğmesi kalmadığı için ölüydü. Kullanıcı: "basılıp
   büyütülsün, zoom düzgün olsun, mobil ve PC'de aynı mantık."

   V153 — AKICI KAYDIRMA: V152'de kaydırma bırakılınca görsel parmağın
   olduğu yerden sıçrıyor, yeni görsel yarı saydam gelip kayıyordu (kullanıcı:
   "çok garip geçiyor"). Şimdi gerçek kaydırıcı: üç yuva (önceki/şimdiki/
   sonraki) bir RAY üzerinde yan yana durur; parmakla birlikte üçü aynı anda
   kayar; bırakınca hız + mesafeye göre karar verilir ve ray 320ms yay
   eğrisiyle yerine oturur; sonra indeks sessizce ilerler, ray anında
   sıfırlanır, komşular yeniden atanır (kullanıcı hiçbir sıçrama görmez).
   Açılış: perde solar + görsel .96→1 (200ms). Kapanış: 170ms solma.
   Aşağı çekme: görsel parmağı izler, perde açılır; bırakınca ya kapanır
   ya yayla döner.

   Zoom durumu (yalnız ŞİMDİKİ yuva): { s 1..4, tx, ty }. Zoom her zaman
   imlecin/çimdiğin olduğu noktaya doğru (görüntü-uzayı koordinatı sabit);
   sınırlar clamp'li; jest sırasında transition yok; programatik geçişte
   260ms ease. Yazımlar SENKRON (rAF'a bağlanınca kare atlandığında durum ile
   DOM ayrışıyordu — ölçüldü).

   Jestler: çimdik · sürükleme (büyükken gezme) · yana kaydırma (s=1) ·
   aşağı çekme (s=1) · çift dokunuş (dokunmatik) / tek tık (fare) → 2.5× ·
   tekerlek · ok tuşları, +/-, 0, Escape. Erişilebilirlik: dialog/aria-modal,
   odak yönetimi, Tab döngüsü. Reduced-motion: geçişler kapalı.
   Fail-open: dosya yüklenmezse galeri sahnesi olduğu gibi çalışır.
   API: window.DenaHexLightbox.open(items, index)  items: [{src, alt, w, h}]
   ============================================================================ */
(function () {
  'use strict';
  if (window.DenaHexLightbox) return;

  var MAX = 4, TAP_ZOOM = 2.5;
  var EASE = 'cubic-bezier(.22,.75,.25,1)';
  /* V154: ray geçişi daha uzun ve yumuşak (kullanıcı: 'daha yumuşak geçsin') */
  var SLIDE_EASE = 'cubic-bezier(.3,.1,.2,1)';
  var SLIDE_MS = 420, ZOOM_MS = 260, OPEN_MS = 200, CLOSE_MS = 170, HOVER_MS = 160;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var root = null, bg, stage, track, slots = [], xBtn, prevBtn, nextBtn, countEl;
  var items = [], at = 0, open = false, lastFocus = null, prevOv = '', prevOb = '';
  var vw = 0, vh = 0;
  var st = { s: 1, tx: 0, ty: 0 };   /* şimdiki görselin zoom durumu */
  var rail = { x: 0, y: 0 };          /* rayın konumu (kaydırma / aşağı çekme) */
  var busy = false;                   /* ray animasyonu sürüyor */
  var ptrs = {}, g = null;
  var lastTap = { t: 0, x: 0, y: 0 };
  var hover = null; /* V154: fare basılı değilken gezinme için son konum */
  var closeTimer = 0, slideTimer = 0;

  /* ---------- kurulum ---------- */
  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'hxl';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Image viewer');
    root.innerHTML =
      '<div class="hxl-bg" data-hxl-close></div>' +
      '<div class="hxl-stage" data-hxl-stage><div class="hxl-track">' +
        '<div class="hxl-slot" data-pos="-1"><img class="hxl-img" alt="" draggable="false"></div>' +
        '<div class="hxl-slot" data-pos="0"><img class="hxl-img" alt="" draggable="false"></div>' +
        '<div class="hxl-slot" data-pos="1"><img class="hxl-img" alt="" draggable="false"></div>' +
      '</div></div>' +
      '<button type="button" class="hxl-btn hxl-x" data-hxl-close aria-label="Close image viewer">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
      '<button type="button" class="hxl-btn hxl-nav hxl-prev" data-hxl-step="-1" aria-label="Previous image">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 5-7 7 7 7"/></svg></button>' +
      '<button type="button" class="hxl-btn hxl-nav hxl-next" data-hxl-step="1" aria-label="Next image">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 5 7 7-7 7"/></svg></button>' +
      '<span class="hxl-count" data-hxl-count aria-live="polite"></span>';
    document.body.appendChild(root);
    bg = root.querySelector('.hxl-bg');
    stage = root.querySelector('[data-hxl-stage]');
    track = root.querySelector('.hxl-track');
    slots = Array.prototype.slice.call(root.querySelectorAll('.hxl-slot'));
    xBtn = root.querySelector('.hxl-x');
    prevBtn = root.querySelector('.hxl-prev');
    nextBtn = root.querySelector('.hxl-next');
    countEl = root.querySelector('[data-hxl-count]');
    slots.forEach(function (sl) {
      var im = sl.querySelector('img');
      im.addEventListener('load', function () { im.classList.remove('is-loading'); });
    });
    bind();
  }
  function curImg() { return slots[1].querySelector('img'); }
  function idx(n) { return (n % items.length + items.length) % items.length; }

  /* ---------- geometri ---------- */
  function fitOf(it) {
    var ar = (it && it.w && it.h) ? it.w / it.h : 1;
    var padX = 24, padY = 96;
    var w = Math.min(vw - padX * 2, (vh - padY * 2) * ar);
    return { w: w, h: w / ar };
  }
  function layout() {
    vw = window.innerWidth; vh = window.innerHeight;
    slots.forEach(function (sl, k) {
      var pos = k - 1;
      sl.style.transform = 'translate3d(' + (pos * vw) + 'px,0,0)';
      var im = sl.querySelector('img');
      var it = items.length ? items[idx(at + pos)] : null;
      var f = fitOf(it);
      im.style.width = Math.round(f.w) + 'px';
      im.style.height = Math.round(f.h) + 'px';
    });
  }
  function clamp() {
    var f = fitOf(items[at]);
    var hw = f.w * st.s / 2, hh = f.h * st.s / 2;
    var mx = Math.max(0, hw - vw / 2), my = Math.max(0, hh - vh / 2);
    st.tx = Math.max(-mx, Math.min(mx, st.tx));
    st.ty = Math.max(-my, Math.min(my, st.ty));
  }
  function paintZoom() {
    curImg().style.transform = 'translate3d(' + st.tx.toFixed(2) + 'px,' + st.ty.toFixed(2) + 'px,0) scale(' + st.s.toFixed(4) + ')';
    root.classList.toggle('is-zoomed', st.s > 1.01);
  }
  function paintRail() {
    track.style.transform = 'translate3d(' + rail.x.toFixed(2) + 'px,' + rail.y.toFixed(2) + 'px,0)';
  }
  function zoomTransition(on) {
    curImg().style.transition = (on && !reduce) ? 'transform ' + ZOOM_MS + 'ms ' + EASE : 'none';
  }
  function railTransition(on) {
    track.style.transition = (on && !reduce) ? 'transform ' + SLIDE_MS + 'ms ' + SLIDE_EASE : 'none';
  }
  function zoomAt(px, py, s2) {
    hover = null;
    s2 = Math.max(1, Math.min(MAX, s2));
    var cx = vw / 2 + st.tx, cy = vh / 2 + st.ty;
    var ux = (px - cx) / st.s, uy = (py - cy) / st.s;
    st.s = s2;
    st.tx = px - vw / 2 - ux * s2;
    st.ty = py - vh / 2 - uy * s2;
    clamp(); paintZoom();
  }
  function resetZoom(animated) {
    hover = null;
    zoomTransition(animated);
    st.s = 1; st.tx = 0; st.ty = 0;
    paintZoom();
  }

  /* ---------- yuvalara görsel atama ---------- */
  function fill() {
    slots.forEach(function (sl, k) {
      var im = sl.querySelector('img');
      var pos = k - 1;
      var it = null;
      if (items.length === 1 && pos !== 0) it = null;
      else it = items[idx(at + pos)];
      var src = it ? it.src : '';
      if (im.getAttribute('src') !== src) {
        im.classList.toggle('is-loading', !!src);
        if (src) im.src = src; else im.removeAttribute('src');
        if (src && im.complete && im.naturalWidth) im.classList.remove('is-loading');
      }
      im.alt = it ? (it.alt || '') : '';
      im.style.transform = '';
      im.style.transition = 'none';
    });
    countEl.textContent = (at + 1) + ' / ' + items.length;
    layout();
  }
  /* geçiş bitti: indeksi ilerlet, rayı sessizce sıfırla */
  function commit(newAt) {
    at = idx(newAt);
    railTransition(false);
    rail.x = 0; rail.y = 0; paintRail();
    st.s = 1; st.tx = 0; st.ty = 0;
    fill();
    busy = false;
    bg.style.opacity = '';
  }
  /* dir: -1 önceki, +1 sonraki — ray komşuya kayar, sonra commit */
  function slide(dir) {
    if (busy || items.length < 2) return;
    busy = true;
    if (st.s > 1.01) resetZoom(false);
    railTransition(true);
    rail.x = -dir * vw; rail.y = 0; paintRail();
    clearTimeout(slideTimer);
    if (reduce) { commit(at + dir); return; }
    slideTimer = setTimeout(function () { commit(at + dir); }, SLIDE_MS + 20);
  }
  function settleRail() {
    railTransition(true);
    rail.x = 0; rail.y = 0; paintRail();
    bg.style.opacity = '';
  }

  /* ---------- aç / kapat ---------- */
  function openAt(list, index) {
    build();
    items = list || [];
    if (!items.length) return;
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    open = true; busy = false;
    at = idx(index || 0);
    root.hidden = false;
    root.classList.remove('is-in', 'is-closing', 'is-zoomed');
    root.classList.toggle('is-solo', items.length < 2);
    prevOv = document.documentElement.style.overflow;
    prevOb = document.documentElement.style.overscrollBehavior;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehavior = 'none';
    st.s = 1; st.tx = 0; st.ty = 0; rail.x = 0; rail.y = 0;
    railTransition(false); paintRail();
    fill();
    bg.style.opacity = '';
    /* bir sonraki stil hesabında giriş geçişi tetiklensin */
    void root.offsetWidth;
    if (reduce) root.classList.add('is-in');
    else setTimeout(function () { if (open) root.classList.add('is-in'); }, 16);
    try { xBtn.focus({ preventScroll: true }); } catch (e) {}
  }
  function finishClose() {
    root.hidden = true;
    root.classList.remove('is-in', 'is-closing', 'is-zoomed');
    document.documentElement.style.overflow = prevOv;
    document.documentElement.style.overscrollBehavior = prevOb;
    ptrs = {}; g = null; busy = false;
    if (lastFocus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function close() {
    if (!open) return;
    open = false;
    clearTimeout(slideTimer); clearTimeout(closeTimer);
    if (reduce) { finishClose(); return; }
    root.classList.add('is-closing');
    closeTimer = setTimeout(finishClose, CLOSE_MS + 10);
  }

  /* ---------- jestler ---------- */
  function dist(a, b) { var dx = a.x - b.x, dy = a.y - b.y; return Math.sqrt(dx * dx + dy * dy); }
  function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
  function two() { var k = Object.keys(ptrs); return k.length >= 2 ? [ptrs[k[0]], ptrs[k[1]]] : null; }

  function onDown(e) {
    if (!open || busy || e.button > 0) return;
    if (e.target.closest && e.target.closest('.hxl-btn')) return;
    e.preventDefault();
    try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    var now = Date.now();
    ptrs[e.pointerId] = { x: e.clientX, y: e.clientY, x0: e.clientX, y0: e.clientY, t0: now, type: e.pointerType, hist: [{ x: e.clientX, y: e.clientY, t: now }] };
    zoomTransition(false); railTransition(false);
    var pair = two();
    if (pair) {
      var m = mid(pair[0], pair[1]);
      var cx = vw / 2 + st.tx, cy = vh / 2 + st.ty;
      /* çimdik yatay kaydırma sırasında başladıysa rayı sessizce geri al */
      rail.x = 0; rail.y = 0; paintRail(); bg.style.opacity = '';
      g = { kind: 'pinch', d0: dist(pair[0], pair[1]), s0: st.s, ux: (m.x - cx) / st.s, uy: (m.y - cy) / st.s };
    } else {
      g = { kind: 'drag', tx0: st.tx, ty0: st.ty, moved: false, axis: null };
    }
  }
  /* V154 — FAREYLE GEZİNME (basılı tutmadan): masaüstü büyütmelerinde alışılmış
     davranış. Göreli eşleme: fare ekranın %84'ünü kat edince görüntü bir uçtan
     öbür uca gider; tıklamayla yapılan zoom'un noktası bozulmaz (mutlak eşleme
     ilk harekette sıçratıyordu). 160ms ease-out ile akıcı. Dokunmatikte yok. */
  function hoverPan(e) {
    if (!open || busy || st.s <= 1.01 || e.pointerType !== 'mouse') { hover = null; return; }
    if (!hover) { hover = { x: e.clientX, y: e.clientY }; return; }
    var f = fitOf(items[at]);
    var mx = Math.max(0, f.w * st.s / 2 - vw / 2), my = Math.max(0, f.h * st.s / 2 - vh / 2);
    var kx = (2 * mx) / (vw * 0.84), ky = (2 * my) / (vh * 0.84);
    st.tx -= (e.clientX - hover.x) * kx;
    st.ty -= (e.clientY - hover.y) * ky;
    hover = { x: e.clientX, y: e.clientY };
    clamp();
    curImg().style.transition = reduce ? 'none' : 'transform ' + HOVER_MS + 'ms ease-out';
    paintZoom();
  }
  function onMove(e) {
    var p = ptrs[e.pointerId];
    if (!open) return;
    if (!p || !g) { hoverPan(e); return; }
    hover = null;
    p.x = e.clientX; p.y = e.clientY;
    var now = Date.now();
    p.hist.push({ x: p.x, y: p.y, t: now });
    if (p.hist.length > 6) p.hist.shift();
    if (g.kind === 'pinch') {
      var pair = two();
      if (!pair) return;
      var m = mid(pair[0], pair[1]);
      var s2 = Math.max(1, Math.min(MAX, g.s0 * dist(pair[0], pair[1]) / Math.max(1, g.d0)));
      st.s = s2;
      st.tx = m.x - vw / 2 - g.ux * s2;
      st.ty = m.y - vh / 2 - g.uy * s2;
      clamp(); paintZoom();
      return;
    }
    var dx = p.x - p.x0, dy = p.y - p.y0;
    if (!g.moved && Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
    g.moved = true;
    if (st.s > 1.01) {
      st.tx = g.tx0 + dx; st.ty = g.ty0 + dy; clamp(); paintZoom();
      return;
    }
    /* s = 1: eksen ilk harekette kilitlenir */
    if (!g.axis) g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    if (g.axis === 'x') {
      rail.x = items.length > 1 ? dx : dx * 0.28; rail.y = 0;
    } else {
      rail.y = dy > 0 ? dy : dy * 0.28; rail.x = 0;
      bg.style.opacity = String(Math.max(.3, 1 - Math.max(0, dy) / 420));
    }
    paintRail();
  }
  function velocity(p) {
    var h = p.hist, n = h.length;
    if (n < 2) return { vx: 0, vy: 0 };
    var a = h[Math.max(0, n - 4)], b = h[n - 1];
    var dt = Math.max(16, b.t - a.t); /* en az bir kare: anlık olaylarda sonsuz hız üretmesin */
    return { vx: (b.x - a.x) / dt, vy: (b.y - a.y) / dt };
  }
  function onUp(e) {
    var p = ptrs[e.pointerId];
    if (!open || !p) return;
    delete ptrs[e.pointerId];
    var nPtr = Object.keys(ptrs).length;
    try { stage.releasePointerCapture(e.pointerId); } catch (err) {}
    if (g && g.kind === 'pinch') {
      if (nPtr === 0) { g = null; if (st.s < 1.04) resetZoom(true); else { zoomTransition(true); clamp(); paintZoom(); } }
      else { var k = Object.keys(ptrs)[0]; ptrs[k].x0 = ptrs[k].x; ptrs[k].y0 = ptrs[k].y; g = { kind: 'drag', tx0: st.tx, ty0: st.ty, moved: true, axis: null }; }
      return;
    }
    if (!g) return;
    var dx = p.x - p.x0, dy = p.y - p.y0;
    var moved = g.moved, axis = g.axis;
    g = null;
    if (!moved) {
      if (e.target === bg) { close(); return; }
      var now = Date.now();
      var isMouse = p.type === 'mouse';
      var dbl = now - lastTap.t < 320 && Math.abs(p.x - lastTap.x) < 30 && Math.abs(p.y - lastTap.y) < 30;
      lastTap = { t: now, x: p.x, y: p.y };
      if (isMouse || dbl) {
        lastTap.t = 0;
        zoomTransition(true);
        if (st.s > 1.01) resetZoom(true); else zoomAt(p.x, p.y, TAP_ZOOM);
      }
      return;
    }
    if (st.s > 1.01) { zoomTransition(true); clamp(); paintZoom(); return; }
    var v = velocity(p);
    if (axis === 'x') {
      /* mesafe ya da fırlatma; fırlatma yolu en az 28px ister (kazara değişim olmasın) */
      var goNext = (dx < 0 && (dx < -vw * 0.22 || (v.vx < -0.45 && dx < -28)));
      var goPrev = (dx > 0 && (dx > vw * 0.22 || (v.vx > 0.45 && dx > 28)));
      if (items.length > 1 && (goNext || goPrev)) { busy = true; slideFrom(goNext ? 1 : -1); return; }
      settleRail(); return;
    }
    if (dy > 120 || (v.vy > 0.5 && dy > 40)) { close(); return; }
    settleRail();
  }
  /* parmak bıraktıktan sonra ray mevcut konumundan komşuya akar */
  function slideFrom(dir) {
    railTransition(true);
    rail.x = -dir * vw; rail.y = 0; paintRail();
    clearTimeout(slideTimer);
    if (reduce) { commit(at + dir); return; }
    slideTimer = setTimeout(function () { commit(at + dir); }, SLIDE_MS + 20);
  }
  function onWheel(e) {
    if (!open || busy) return;
    e.preventDefault();
    var k = Math.exp(-e.deltaY * 0.0022);
    zoomTransition(false);
    zoomAt(e.clientX, e.clientY, st.s * k);
    clearTimeout(onWheel.t);
    onWheel.t = setTimeout(function () { if (st.s < 1.04) resetZoom(true); }, 120);
  }
  function onKey(e) {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); slide(1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); slide(-1); }
    else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomTransition(true); zoomAt(vw / 2, vh / 2, st.s * 1.4); }
    else if (e.key === '-') { e.preventDefault(); zoomTransition(true); zoomAt(vw / 2, vh / 2, st.s / 1.4); if (st.s < 1.04) resetZoom(true); }
    else if (e.key === '0') { e.preventDefault(); resetZoom(true); }
    else if (e.key === 'Tab') {
      var f = [xBtn, prevBtn, nextBtn].filter(function (b) { return b && b.offsetParent !== null; });
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey) { if (i <= 0) { e.preventDefault(); f[f.length - 1].focus(); } }
      else if (i === -1 || i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
  }
  function bind() {
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onUp);
    stage.addEventListener('wheel', onWheel, { passive: false });
    stage.addEventListener('dblclick', function (e) { e.preventDefault(); });
    root.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-hxl-close]');
      if (c && c !== bg) { close(); return; }
      var s = e.target.closest && e.target.closest('[data-hxl-step]');
      if (s) slide(parseInt(s.getAttribute('data-hxl-step'), 10));
    });
    bg.addEventListener('click', function () { close(); });
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', function () { if (open) { layout(); clamp(); paintZoom(); } });
  }

  window.DenaHexLightbox = { open: openAt, close: close };
})();
